"use client";
import { useRef } from "react";
import { LoadingScreen } from "@/components/layout/LoadingScreen";
import { useAuthenticationStatus } from "@/lib/nhost/react";
import { useToPath } from "../hooks";
import AuthNav from "../nav";

const SignedInLayoutContent = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuthenticationStatus();
  const isRedirectingRef = useRef(false);

  const toPath = useToPath();

  if (isAuthenticated) {
    if (!isRedirectingRef.current) {
      // Use hard reload to ensure JWT headers are properly set
      window.location.href = toPath.pathname + toPath.search + toPath.hash;
    }
    isRedirectingRef.current = true;
    return <LoadingScreen />;
  } else {
    return (
      <div>
        <AuthNav />
        <div className="min-h-screen mt-20">{children}</div>
      </div>
    );
  }
};

// NhostProvider is already provided by parent LayoutContent.tsx
// Adding another one here caused duplicate token refresh requests
export default function SignedInLayout({ children }: { children: React.ReactNode }) {
  return <SignedInLayoutContent>{children}</SignedInLayoutContent>;
}
